import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

export const matchesAPI = {
  getAll: (params) => api.get('/matches', { params }),
  getById: (id) => api.get(`/matches/${id}`),
  getByTeam: (team) => api.get(`/matches/team/${encodeURIComponent(team)}`),
};

export const teamsAPI = {
  getAll: () => api.get('/teams'),
  getById: (id) => api.get(`/teams/${id}`),
};

export const stadiumsAPI = {
  getAll: () => api.get('/stadiums'),
  getById: (id) => api.get(`/stadiums/${id}`),
};

export const citiesAPI = {
  getAll: () => api.get('/cities'),
  getById: (id) => api.get(`/cities/${id}`),
  getAttractions: (cityId) => api.get(`/cities/${cityId}/attractions`),
  getTours: (cityId) => api.get(`/cities/${cityId}/tours`),
};

export const eventsAPI = {
  getAll: (params) => api.get('/events', { params }),
  create: (data) => api.post('/events', data),
};

export const plannerAPI = {
  itinerary: (data) => api.post('/planner/itinerary', data),
  trip: (data) => api.post('/planner/trip', data),
};

export const newsAPI = {
  getAll: () => api.get('/news'),
};

export const standingsAPI = {
  getAll: (params) => api.get('/standings', { params }),
};

export const worldcupAPI = {
  getTeams: () => api.get('/worldcup/teams'),
  getFixtures: () => api.get('/worldcup/fixtures'),
  getGroups: () => api.get('/worldcup/groups'),
  getMatch: (id) => api.get(`/worldcup/match/${id}`),
};

export const predictionsAPI = {
  h2h: (team1, team2) => api.get(`/h2h/${encodeURIComponent(team1)}/${encodeURIComponent(team2)}`),
  winProbability: (matchId) => api.get(`/predictions/${matchId}`),
};
